import { Route, Routes, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { useRecoilState } from 'recoil';
import './App.css';
import Login from './components/Login';
import Home from './components/Home';
import loginStateAtom from './atoms/loginStateAtom';
import myInfoAtom from './atoms/myInfoAtom';
import axios from 'axios';
import { url } from './utils/config';
import { useEffect } from 'react';
import uiConfigAtom from './atoms/uiConfigAtom';

function App() {
  const [ loggedIn, setLoggedIn ] = useRecoilState(loginStateAtom);
  const [ myInfo, setMyInfo ] = useRecoilState(myInfoAtom);
  const [ uiConfig, setUiConfig ] = useRecoilState(uiConfigAtom);

  
  useEffect(() => {
    getUiConfig()
  }, [])

  useEffect(() => {
    fetchMyInfo();
  }, [ loggedIn ])

  
  async function fetchMyInfo() {
    if (Object.keys(myInfo).length === 0 && loggedIn === true) {
      try {
        const reqUrl = url + '/my_info';
        const token = window.localStorage.getItem('token');
        const headers = { authorization: `bearer ${token}` };
        const { data } = await axios.get(reqUrl, { headers });
        setMyInfo(data);
      } catch (error) {
        console.log(error)
      }
    }
  }

  async function getUiConfig() {
    if(uiConfig === null) {
      try {
        const reqUrl = url + '/ui_config';
        const { data } = await axios.get(reqUrl);
       data.data?.config &&  setUiConfig(JSON.parse(data.data.config))
      } catch (error) {
        console.log(error)
      }
    }
  }

  return (
    <div style={{fontFamily: uiConfig?.fontData?.fontFamily, fontSize: uiConfig?.fontData?.fontSize}}>
      <ToastContainer autoClose={false} />
      <Routes>
        <Route path='/login' element={ !loggedIn ? <Login /> : <Navigate to={'/'} /> } /> 
        <Route path='/*' element={loggedIn ? <Home /> : <Login /> } />
      </Routes>
    </div>
  );
}

export default App;
